import { render } from "./ContainerWithErrors.vue?vue&type=template&id=5bcd7e47"
import script from "./ContainerWithErrors.vue?vue&type=script&lang=js"
export * from "./ContainerWithErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__